import React from 'react';
import MatchList from '../common/MatchList';

export default function Fixtures(props) {
  return (
    <MatchList
      {...props}
      teamLayout="versus"
      subtitle="Fixtures"
      emptyMessage="No upcoming fixtures in the feed for this competition. Try Live scores or another league."
    />
  );
}
